import React, { useState } from 'react';
import { useEffect } from 'react';
import './assets/css/style.scss';
import logo from './../../../assets/images/white_logo.png';
import { Link } from 'react-router-dom';
import { Branch } from '../../../shared/interfaces';
import RegisterModal from '../RegisterModal/RegisterModal';

function HeaderV2() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [branches, setBranches] = useState<Branch[]>([]);

  const [showRegister, setShowRegister] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    fetch(`https://strapi-production-a706.up.railway.app/api/branches?sort=order:ASC`)
      .then((res) => res.json())
      .then((data) => setBranches(data.data))
      .catch((err) => console.error('Failed to fetch acitivies:', err));
  }, []);

  return (
    <div className={`header ${scrollPosition > 0 ? 'header--scrolled' : ''}  `}>
      <div className="header__logo">
        <Link to={'/'}>
          <img src={logo} alt="logo" />
        </Link>
      </div>
      <div className="header__menu">
        <ul className="main-menu">
          <li>
            <Link to="/">Faqja Kryesore</Link>
          </li>
          <li className="has-submenu">
            <span>Ku Gjendemi?</span>
            <ul className="submenu">
              {branches?.map((branch) => (
                <li key={branch.id}>
                  <Link to={`/filiali/${branch.city}`}>{branch?.city}</Link>
                </li>
              ))}
            </ul>
          </li>
          <li>
            <Link to="/artikuj">Artikuj</Link>
          </li>
          <li>
            <Link to="/botime">Botime Akropoli i Ri</Link>
          </li>
        </ul>
      </div>
      <div className="header__action">
        <button className="button button--primary" onClick={() => setShowRegister(true)}>
          <span>Regjistrohu Tani</span>
        </button>
      </div>

      {showRegister && <RegisterModal show={showRegister} onHide={() => setShowRegister(false)} />}
    </div>
  );
}

export default HeaderV2;
